
// 2026-09-30：按路由隔离手机页布局，详情与结算不占底部分类导航空间。
import {mobilePageClass,showMobileTabs} from '@/utils/mobilePresentation'
import NotificationExperiencePreview from "@/components/NotificationExperiencePreview.vue"
import Navbar from './components/Navbar.vue'
import WechatBindingReminder from '@/components/WechatBindingReminder.vue'
import AppMain from './components/AppMain.vue'
import Sidebar from './components/sidebar/index.vue'
import LevelCard from '@/views/main/components/levelCard.vue'
import router from '@/router'
import variables from '@/assets/styles/variables.module.scss'
import store from '@/store'
import { defineComponent, ref, onMounted, onBeforeUnmount, watch, computed } from 'vue'
import sysRequest from '@/api/sys'
export default defineComponent({
  components: {
    NotificationExperiencePreview,
    WechatBindingReminder, Navbar, AppMain, Sidebar,LevelCard
  },
  setup() {
    const path=computed(()=>{
      return router.currentRoute.value.path
    })    
    // 管理端手动续期后，无需退出：前台每分钟及切页/返回窗口时读取本人最新资料。
    let refreshBusy=false,lastRefresh=0,disposed=false
    const memberIdentity=()=>JSON.stringify([store.getters.orgId,store.getters.userInfo?.id])
    async function refreshMembership(){
      if(disposed || document.visibilityState==='hidden' || refreshBusy || !store.getters.token || !store.getters.userInfo?.id || Date.now()-lastRefresh<30000)return
      refreshBusy=true;lastRefresh=Date.now()
      try{await store.dispatch('user/refreshMemberSnapshot')}catch{/* 保留当前资料，后续重新读取；不将网络失败视为会员过期。 */}finally{refreshBusy=false}
    }
    const foregroundRefresh=()=>{void refreshMembership()}
    watch(()=>[memberIdentity(),path.value],()=>{void refreshMembership()})
    let memberTimer:ReturnType<typeof setInterval>|undefined
    onMounted(()=>{void refreshMembership();memberTimer=setInterval(foregroundRefresh,60000);document.addEventListener('visibilitychange',foregroundRefresh);window.addEventListener('focus',foregroundRefresh)})
    onBeforeUnmount(()=>{disposed=true;clearInterval(memberTimer);document.removeEventListener('visibilitychange',foregroundRefresh);window.removeEventListener('focus',foregroundRefresh)})
    const scrolltop=ref(0)
    onMounted(() => {
      const ele=document.querySelector('.app-main')
      if(ele){
        ele?.addEventListener('scroll', ()=>{
          scrolltop.value=ele.scrollTop
        })
      }
      
    })
    return {
      variables, store,path,scrolltop,mobilePageClass,showMobileTabs
    }
  }
})
